import { Box } from "@chakra-ui/react"

export const ContentAccordionRight = ({ children }: { children?: React.ReactNode }) => {
  if (!children) return null

  return (
    <Box
      py="5"
      px="12"
      fontSize="md"
      borderColor="blackAlpha.200"
      sx={{
        flex: "0 0 100%",
        borderTopWidth: "1px",
        borderTopStyle: "solid",
        "@container (min-width: 1400px)": {
          flex: "1 1 320px",
          maxWidth: "440px",
          minWidth: "320px",
          py: "10",
          borderTopStyle: "none",
          borderLeftWidth: "1px",
          borderLeftStyle: "solid",
        },
      }}
    >
      {children}
    </Box>
  )
}
